<script>
import Vue from 'vue'

import SanitasAccordion from '@/modules/collapsible/SanitasAccordion'
import SanitasCollapsible from '@/modules/collapsible/SanitasCollapsible'
import CheckboxGroup from '@/modules/forms/components/CheckboxGroup'
import SanitasForm from '@/modules/forms/components/Form'
import HouseKeyError from '@/modules/forms/components/HouseKeyError'
import HouseKeyModule from '@/modules/forms/components/HouseKeyModule'
import SanitasInputFile from '@/modules/forms/components/InputFile'
import SanitasInputWrapper from '@/modules/forms/components/InputWrapper'
import RadioGroupWrapper from '@/modules/forms/components/RadioGroupWrapper'
import SanitasTooltip from '@/modules/forms/components/SanitasTooltip'
import Validate from '@/modules/forms/directives/validate'

Vue.directive('validate', Validate)
export default {
  name: 'WizardDynamic',

  components: {
    Icon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    SanitasButton: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/SanitasButton'
      )
    },
    RadioGroup: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/RadioGroup'
      )
    },
    DateInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/DateInput'
      )
    },
    TextInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/TextInput'
      )
    },
    Checkbox: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/Checkbox'
      )
    },
    Radio: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/Radio'
      )
    },
    PhoneNumberInput: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/PhoneNumberInput'
      )
    },
    SanTextArea: () => {
      return import(
        /* webpackChunkName: "sanitas-components" */
        '@/components/sanitas-components/Textarea'
      )
    },
    SanitasAccordion,
    SanitasCollapsible,
    SanitasInputWrapper,
    SanitasForm,
    CheckboxGroup,
    SanitasTooltip,
    RadioGroupWrapper,
    SanitasInputFile,
    HouseKeyModule,
    HouseKeyError,
  },
  props: {
    template: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      templateRender: null,
    }
  },
  watch: {
    template: {
      immediate: true,
      handler(value) {
        if (value) {
          const res = Vue.compile(value)

          this.templateRender = res.render

          this.$options.staticRenderFns = []

          this._staticTrees = []

          // Fill it with the new staticRenderFns
          for (let i in res.staticRenderFns) {
            //staticRenderFns.push(res.staticRenderFns[i]);
            this.$options.staticRenderFns.push(res.staticRenderFns[i])
          }
        }
      },
    },
  },
  render(h) {
    if (!this.templateRender) {
      return h('div', 'Content is loading...')
    } else {
      // If there is a template, I'll show it
      return this.templateRender()
    }
  },
}
</script>
